import React from 'react'

const BusinessIdStatus = (props) => {
  const { state } = props
  let statusBox = (
    <span className='bg-success p-xs' style={{ cursor: 'default' }}>
      {state || 'N/A'}
    </span>
  )

  if (state) {
    if (state.toLowerCase() === 'rejected') {
      statusBox = (
        <span className='bg-danger p-xs' style={{ cursor: 'default' }}>
          {state || 'N/A'}
        </span>
      )
    } else if (state.toLowerCase() === 'open') {
      statusBox = (
        <span className='bg-primary p-xs' style={{ cursor: 'default' }}>
          {state || 'N/A'}
        </span>
      )
    } else if (state.toLowerCase() === 'accepted') {
      statusBox = (
        <span className='bg-success p-xs' style={{ cursor: 'default' }}>
          approved
        </span>
      )
    } else if (state.toLowerCase() === 'hold') {
      statusBox = (
        <span
          className='p-xs'
          style={{
            cursor: 'default',
            backgroundColor: '#A9A9A9',
            color: 'white',
          }}
        >
          {state || 'N/A'}
        </span>
      )
    }
  }

  return (
    <div>
      <div className='ibox-title round-corner-box-top'>
        <h5>Status</h5>
      </div>
      <div className='ibox-content round-corner-box-bottom text-center text-uppercase'>{statusBox}</div>
    </div>
  )
}

export default BusinessIdStatus
